import React from 'react';
import clsx from 'clsx';

export function TableRow({
    children,
    hover,
    onClick,
    onContextMenu,
    status,
}: {
    children: React.ReactNode;
    hover?: boolean;
    onClick?: () => void;
    onContextMenu?: (event: React.MouseEvent) => void;
    status?: string | undefined;
}) {
    const shouldHover = hover ? 'hover:bg-surface-muted cursor-pointer transition-colors' : '';
    const statusClass = status || '';

    const className = clsx(
        'border-b border-border-subtle last:border-b-0',
        shouldHover,
        statusClass
    );

    return (
        <tr className={className} onClick={onClick} onContextMenu={onContextMenu}>
            {children}
        </tr>
    );
}
